import {useTranslations} from 'next-intl';

const useDataProtectionTabItems = () => {
  const t = useTranslations('legal.tabs.dataProtection');

  return [
    {
      text: t('dataProcessingAddendum'),
      value: 'data-processing-addendum',
      child: true
    },
    {
      text: t('ccpaCpra'),
      value: 'CCPA/CPRA',
      child: true
    },
    {
      text: t('subProcessors'),
      value: 'sub-processors',
      child: false,
      routerPushUrl: '/subprocessors'
    },
    {
      text: t('securityMeasures'),
      value: 'security-measures',
      child: true
    }
  ];
};

export default useDataProtectionTabItems;
